<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-import-button/lecture-import-button.component.ts.LectureImportButtonComponent.html